import React from "react";
import Modal from "react-bootstrap/Modal";

const UnitModal = ({
  show,
  onClose,
  unit,
  setUnit,
  unitError,
  onSubmit,
  disableSubmit
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add Unit</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="input-block local-forms">
          <label>
            Unit Name <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
            placeholder="Enter Unit name"
          />

          {unitError && (
            <div className="error text-danger mt-1">{unitError}</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnitModal;
